export default defineNuxtRouteMiddleware((to, from) => {
  if (to.fullPath.startsWith('/app/onboarding')) {
    return;
  }

  if (to.fullPath.startsWith('/app')) {
    return;
  }
});
